import BaseInputAdornment from '@material-ui/core/InputAdornment'

const InputAdornment = BaseInputAdornment

export default InputAdornment
